// The route check for the mock state harness, kept apart from the harness itself so the dashboard can
// decide whether to show it without loading its fixtures.
export const TEST_STATES_RESTAURANT_ID = '9999';
export const TEST_STATES_QUERY_FLAG = 'testPage';

// True for `/9999?testPage` only, so a real shop can never be shadowed by the harness.
export const isTestStatesRoute = (restaurantId: string | undefined, search: string): boolean =>
  restaurantId === TEST_STATES_RESTAURANT_ID && new URLSearchParams(search).has(TEST_STATES_QUERY_FLAG);
